module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel()
      }
    }
  }, [_vm._v("导出excel")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "downForm",
      "method": "get"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386bbc90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/exportExcel2.vue
// module id = 902
// module chunks = 0